// JAWS vs VoiceOver (see doc/jaws-voiceover-accessibility-reference.md §5):
// aria-pressed on each card is sufficient for selection feedback — no #aria_polite duplicate.

import React from 'react'
import { useData } from './DataProvider'
import {
  SolarCase,
  PathArrow,
  JournalPage,
  EntrepreneurshipIcon,
  RetirementIcon,
} from './Icons'
import InterestCard from './InterestCard'
import useTranslation from '../shared/TranslationProvider'

const InterestSelect = ({ is_profile_page, labelledBy }) => {
  const { statoCustomContent } = useData()

  return (
    <fieldset className="m-0 border-0 p-0" aria-labelledby={labelledBy}>
      {statoCustomContent ? (
        <StatoInterestCards />
      ) : (
        <DefaultInterestCards is_profile_page={is_profile_page} />
      )}
    </fieldset>
  )
}
export default InterestSelect

const DefaultInterestCards = ({ is_profile_page }) => {
  const { interest, interestKeys, setInterest } = useData()
  const { t } = useTranslation()

  const [newJob, careerChange, contractJob, workingForSelf, retirement] =
    interestKeys
  const handleInterestClick = (clickedInterest) => {
    setInterest(clickedInterest)
  }

  if (is_profile_page) {
    // Render all 5 cards in a single row
    return (
      <div className="mt-2 flex flex-row flex-wrap justify-center gap-x-4 gap-y-4 sm:gap-x-8">
        <InterestCard
          title={t('interests.new_job')}
          onClick={() => handleInterestClick(newJob)}
          active={interest == newJob}
        >
          <SolarCase active={interest == newJob} />
        </InterestCard>
        <InterestCard
          title={t('interests.career_change')}
          onClick={() => handleInterestClick(careerChange)}
          active={interest == careerChange}
        >
          <PathArrow active={interest == careerChange} />
        </InterestCard>
        <InterestCard
          title={t('interests.contract_job')}
          onClick={() => handleInterestClick(contractJob)}
          active={interest == contractJob}
        >
          <JournalPage active={interest == contractJob} />
        </InterestCard>
        <InterestCard
          title={t('interests.working_for_self')}
          onClick={() => handleInterestClick(workingForSelf)}
          active={interest == workingForSelf}
        >
          <EntrepreneurshipIcon active={interest == workingForSelf} />
        </InterestCard>
        <InterestCard
          title={t('interests.retirement')}
          onClick={() => handleInterestClick(retirement)}
          active={interest == retirement}
        >
          <RetirementIcon active={interest == retirement} />
        </InterestCard>
      </div>
    )
  }

  // Default: 3 on top, 2 on bottom
  return (
    <>
      <div className="flex flex-row justify-center">
        <div className="mr-4 sm:mr-14">
          <InterestCard
            title={t('interests.new_job')}
            onClick={() => handleInterestClick(newJob)}
            active={interest == newJob}
          >
            <SolarCase active={interest == newJob} />
          </InterestCard>
        </div>
        <div className="mr-4 sm:mr-14">
          <InterestCard
            title={t('interests.career_change')}
            onClick={() => handleInterestClick(careerChange)}
            active={interest == careerChange}
          >
            <PathArrow active={interest == careerChange} />
          </InterestCard>
        </div>
        <div className="">
          <InterestCard
            title={t('interests.contract_job')}
            onClick={() => handleInterestClick(contractJob)}
            active={interest == contractJob}
          >
            <JournalPage active={interest == contractJob} />
          </InterestCard>
        </div>
      </div>
      <div className="mt-4 flex flex-row justify-center sm:mt-14">
        <div className="mr-4 sm:mr-14">
          <InterestCard
            title={t('interests.working_for_self')}
            onClick={() => handleInterestClick(workingForSelf)}
            active={interest == workingForSelf}
          >
            <EntrepreneurshipIcon active={interest == workingForSelf} />
          </InterestCard>
        </div>
        <div className="">
          <InterestCard
            title={t('interests.retirement')}
            onClick={() => handleInterestClick(retirement)}
            active={interest == retirement}
          >
            <RetirementIcon active={interest == retirement} />
          </InterestCard>
        </div>
      </div>
    </>
  )
}

const StatoInterestCards = () => {
  const { interest, interestKeys, setInterest } = useData()
  const { t } = useTranslation()

  const [newJob, careerChange, workingForSelf] = interestKeys
  const handleInterestClick = (clickedInterest) => {
    setInterest(clickedInterest)
  }

  return (
    <>
      <div className="flex flex-row justify-center">
        <div className="mr-4 sm:mr-14">
          <InterestCard
            title={t('interests.new_job')}
            onClick={() => handleInterestClick(newJob)}
            active={interest == newJob}
          >
            <SolarCase active={interest == newJob} />
          </InterestCard>
        </div>
        <div className="mr-4 sm:mr-14">
          <InterestCard
            title={t('interests.career_change')}
            onClick={() => handleInterestClick(careerChange)}
            active={interest == careerChange}
          >
            <PathArrow active={interest == careerChange} />
          </InterestCard>
        </div>
        <div className="">
          <InterestCard
            title={t('interests.working_for_self')}
            onClick={() => handleInterestClick(workingForSelf)}
            active={interest == workingForSelf}
          >
            <EntrepreneurshipIcon active={interest == workingForSelf} />
          </InterestCard>
        </div>
      </div>
    </>
  )
}
